
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.203 9l.463-2.895H5.813V4.224c0-.792.398-1.565 1.672-1.565H8.8V.194C8.034.074 7.26.01 6.484 0 4.136 0 2.603 1.388 2.603 3.898v2.207H0V9h2.603V16h3.21V9h2.39z","fill":"#fff"}})])
          )
        }
      }
    